<kodit-dropdown
  [options]="items"
  ctrlTooltip="Izaberite cenovnik"
  ctrlTooltipPosition="top"
  [canFilter]="true"
  (optionChanged)="handleOnItemChange($event)"
></kodit-dropdown>
